// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-V4NU58","card":"card-BCAxXP","title":"title-gXiof_","body":"body-KwWCE8"};